import React, { useState, useContext } from 'react';
import { PoweroffOutlined, BellOutlined, BellFilled, MenuUnfoldOutlined, MenuFoldOutlined, MenuOutlined } from '@ant-design/icons';
import { Tooltip, Button, Drawer, Row, Col, Badge, Select, Divider, Space } from 'antd';
import { translate, setLanguage, getLanguage } from 'react-multi-lang';
import { AllHtmlEntities } from 'html-entities';

import { PerfilUsuariContext } from "../context/perfil-usuari";
import { MenuTriatContext } from "../context/menu-triat";

import logo_menu from '../images/logo_h_transparent.png';
const entities = new AllHtmlEntities();

function MenuSuperior(props){
    const [perfilUsuari, setPerfilUsuari] = useContext(PerfilUsuariContext);
    const [menuTriat, setMenuTriat] = useContext(MenuTriatContext);
    const [menuVisible, setMenuVisible] = useState(false);

    const changeLang = (lang) =>{
        setLanguage(lang);
        sessionStorage.setItem('Language',lang);
      }

    return (
      <>
      <Row justify="space-between">

            <Col span={8} style={{textAlign:'left', paddingLeft:'1rem', paddingTop:'0.5rem'}}>
              <img src={logo_menu} alt="Logo" width="210"/>
            </Col>

            <Col xs={0} sm={0} md={8} lg={6}>
              <div style={{paddingLeft:'24px'}}>
                <span style={{ fontSize: '16px', color: 'white' }}>{props.t('generic.idioma')}:&nbsp;&nbsp;</span>
                <Select defaultValue={getLanguage()} value={getLanguage()} onChange={changeLang} style={{ width: 110}} size="small">
                  <Select.Option value="es">Castellano</Select.Option>
                  <Select.Option value="ca">Català</Select.Option>
                  <Select.Option value="en">English</Select.Option>
                  {/*idiomes*/}
                </Select>
              </div>
            </Col>

            <Col  xs={0} sm={0} md={0} lg={6}>
                <Space>
                  <span style={{ fontSize: '16px', color: 'white' }}>{props.t('login.User')}: {entities.decode(perfilUsuari.account.username)}</span>
                  <Tooltip title={props.t('menu.cerrar_sesion')} placement="left">
                    <Button
                      type="link"
                      className="link-menu-superior"
                      onClick={(e) => setMenuTriat('Logout')}
                      >
                      <PoweroffOutlined style={{ fontSize: '16px', color: 'white' }} />
                    </Button>
                  </Tooltip>
                </Space>
            </Col>


            <Col>
              <Button type="link" icon={<MenuOutlined style={{fontSize: '24px', color: 'white'}}/>} onClick={(e)=>setMenuVisible(!menuVisible)}/>
            </Col>


      </Row>



      <Drawer
          title={<span style={{ fontSize: '16px' }}>{props.t('login.User')}: {entities.decode(perfilUsuari.account.username)}</span>}
          placement="right"
          closable={true}
          onClose={() => setMenuVisible(false)}
          open={menuVisible}
          key="right"
        >
          <Row align="center">

              <span style={{ fontSize: '16px'}}>{props.t('generic.idioma')}:&nbsp;&nbsp;</span>
              <Select defaultValue={getLanguage()} value={getLanguage()} onChange={changeLang} style={{ width: 110}} size="small">
                <Select.Option value="es">Castellano</Select.Option>
                <Select.Option value="ca">Català</Select.Option>
                <Select.Option value="en">English</Select.Option>
                {/*idiomes*/}
              </Select>

          </Row>
          <Divider />
          <Row align="center">
            <Button onClick={(e)=>setMenuTriat("Logout")}>
              <PoweroffOutlined />
              <span>{props.t('menu.cerrar_sesion')}</span>
            </Button>
          </Row>
        </Drawer>
      </>
    );

}

export default translate(MenuSuperior);
